
/**
 * Custom component for New Years default menu sections.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 2.0.0
 * @copyright  Copyright (C) 2024-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *  2024-12-09 (1.0.0) (jhoward)
 *    - Copy from Thanksgiving_defaultSection.vue component to NewYears_defaultSection.vue component.
 *
 *  2025-02-10 (1.1.0) (jhoward)
 *    - Add <menu-schedules> to the <NewYears_defaultSection> component if in admin view.
 *
 *  2025-04-08 (2.0.0) (jhoward)
 *    - Use <default-textual-section> and <default-visual-section> in <NewYears_defaultSection>.
 */

import {defineComponent, PropType} from "vue";
import {ALLOWED_ITEM_COMPONENTS, Menu, MenuSection} from "../defs";
import DefaultVisualSection from "./visual/defaultVisualSection.vue";
import DefaultTextualSection from "./textual/defaultTextualSection.vue";

export default defineComponent({
  components: {
    DefaultTextualSection, DefaultVisualSection,
  },
  name: "NewYears_defaultSection",
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
    menuItemComponent: {
      type: String,
      default: 'new-years-food-item',
      validate: (value: string) => '' === value || ALLOWED_ITEM_COMPONENTS.indexOf(value)
    },
  },
  mounted() {
    this.section.ms_subtitle = this.sectionSubtitle();
  },
  methods: {
    sectionSubtitle(): string {
      if (this.section.ms_title.length) {
        if ('new year\'s eve' === this.section.ms_title.toLowerCase()) {
          return this.section.ms_title.toUpperCase() + ' DINING';
        }

        return this.section.ms_subtitle;
      }

      return (this.menu?.page?.page_h1 || '').toUpperCase();
    },
  },
})
